import * as React from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 96, height: 96, fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#2175D9", fillRule: "evenodd", d: "M48 96c26.51 0 48-21.49 48-48S74.51 0 48 0 0 21.49 0 48s21.49 48 48 48m-4-71a4 4 0 0 1 8 0v19h19a4 4 0 0 1 0 8H52v19a4 4 0 0 1-8 0V52H25a4 4 0 0 1 0-8h19z", clipRule: "evenodd" }));
export default SvgPlus;
